import { render, staticRenderFns } from "./VolumeStats.vue?vue&type=template&id=7311c026&"
import script from "./VolumeStats.vue?vue&type=script&lang=js&"
export * from "./VolumeStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports